const SuccessSignIcon = (props) => (
  <svg {...props} viewBox="0 0 12 9" className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.6665 7.115L10.7945 0.986328L11.7378 1.92899L4.6665 9.00033L0.423828 4.75766L1.3665 3.81499L4.6665 7.115Z" />
  </svg>
);

export default SuccessSignIcon;
